import { Injectable } from '@angular/core';
import { drop, take } from 'lodash-es';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Filter, GqlWatchResponse } from '../models/common.model';
import { GqlQueryCommandService } from './gql-query-command.service';

@Injectable({
    providedIn: 'root'
})
export class PaginationService {
    constructor(private gqlQueryCommandService: GqlQueryCommandService) {}

    correctedPagination<T>(
        propName: string,
        value,
        entityName: string,
        fields: string[],
        filters: Filter[],
        pageSize: number,
        orderBy: string
    ): Observable<GqlWatchResponse<T> & { PageNumber: number; Index: number }> {
        return this.gqlQueryCommandService.gqlWatchQueryGetAll<T>(entityName, fields, filters, orderBy).pipe(
            map(res => {
                const index = res.Data.findIndex(datum => datum[propName] === value);
                let pageData = { Index: -1, PageNumber: 0 };
                if (index !== -1) {
                    const dataSkipped = Math.floor(index / pageSize) * pageSize;
                    res.Data = drop(res.Data, dataSkipped);
                    pageData = { Index: index - dataSkipped, PageNumber: Math.floor(index / pageSize) };
                }
                res.Data = take(res.Data, pageSize);
                return Object.assign({}, res, pageData);
            })
        );
    }

    public static getTotalPage(TotalCount: number) {
        return TotalCount / 10 + (TotalCount % 10 === 0 ? 0 : 1);
    }
}
